/* shop/components/Summary.svelte generated by Svelte v3.59.2 */
import {
	SvelteComponent,
	append,
	attr,
	component_subscribe,
	destroy_each,
	detach,
	element,
	init,
	insert,
	noop,
	safe_not_equal,
	set_data,
	space,
	text
} from "svelte/internal";

import basketStore, {
	basketItemsCount,
	basketPrice,
	basketDiscount
} from "./../basketStore";

import orderStore from "./../orderStore";

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[5] = list[i];
	return child_ctx;
}

// (16:0) {#if $basketItemsCount > 0}
function create_if_block_7(ctx) {
	let div;
	let table;
	let thead;
	let tr0;
	let th0;
	let t1;
	let th1;
	let t3;
	let th2;
	let t5;
	let th3;
	let t7;
	let th4;
	let t9;
	let tbody;
	let t10;
	let tfoot;
	let t11;
	let tr1;
	let td0;
	let t12_value = gettext("Doprava:") + "";
	let t12;
	let t13;
	let t14_value = /*$orderStore*/ ctx[3].delivery_title + "";
	let t14;
	let t15;
	let t16;
	let td1;
	let t17;
	let td2;
	let t18_value = /*$orderStore*/ ctx[3].price_delivery.toLocaleString() + "";
	let t18;
	let t19;
	let t20_value = /*$basketStore*/ ctx[1].payment_currency + "";
	let t20;
	let t21;
	let td3;
	let t22;
	let td4;
	let t23_value = /*$orderStore*/ ctx[3].price_delivery.toLocaleString() + "";
	let t23;
	let t24;
	let t25_value = /*$basketStore*/ ctx[1].payment_currency + "";
	let t25;
	let t26;
	let tr2;
	let td5;
	let t27_value = gettext("Platba:") + "";
	let t27;
	let t28;
	let t29_value = /*$orderStore*/ ctx[3].payment_title + "";
	let t29;
	let t30;
	let td6;
	let t31;
	let td7;
	let t32_value = /*$orderStore*/ ctx[3].price_payment.toLocaleString() + "";
	let t32;
	let t33;
	let t34_value = /*$basketStore*/ ctx[1].payment_currency + "";
	let t34;
	let t35;
	let td8;
	let t36;
	let td9;
	let t37_value = /*$orderStore*/ ctx[3].price_payment.toLocaleString() + "";
	let t37;
	let t38;
	let t39_value = /*$basketStore*/ ctx[1].payment_currency + "";
	let t39;
	let t40;
	let tr3;
	let td10;
	let t42;
	let td11;
	let t43;
	let td12;
	let t44;
	let td13;
	let t45;
	let td14;
	let t46_value = (/*$basketPrice*/ ctx[4] + /*$orderStore*/ ctx[3].price_delivery + /*$orderStore*/ ctx[3].price_payment).toLocaleString() + "";
	let t46;
	let t47;
	let t48_value = /*$basketStore*/ ctx[1].payment_currency + "";
	let t48;
	let each_value = /*$basketStore*/ ctx[1].items;
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	let if_block0 = /*$basketDiscount*/ ctx[2] > 0 && create_if_block_9(ctx);
	let if_block1 = /*$orderStore*/ ctx[3].delivery_data && /*$orderStore*/ ctx[3].delivery_data.subtitleHTML && create_if_block_8(ctx);

	return {
		c() {
			div = element("div");
			table = element("table");
			thead = element("thead");
			tr0 = element("tr");
			th0 = element("th");
			th0.textContent = `${gettext("Položka")}`;
			t1 = space();
			th1 = element("th");
			th1.textContent = `${gettext("Typ")}`;
			t3 = space();
			th2 = element("th");
			th2.textContent = `${gettext("Cena")}`;
			t5 = space();
			th3 = element("th");
			th3.textContent = `${gettext("Počet")}`;
			t7 = space();
			th4 = element("th");
			th4.textContent = `${gettext("Cena celkem")}`;
			t9 = space();
			tbody = element("tbody");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			t10 = space();
			tfoot = element("tfoot");
			if (if_block0) if_block0.c();
			t11 = space();
			tr1 = element("tr");
			td0 = element("td");
			t12 = text(t12_value);
			t13 = space();
			t14 = text(t14_value);
			t15 = space();
			if (if_block1) if_block1.c();
			t16 = space();
			td1 = element("td");
			t17 = space();
			td2 = element("td");
			t18 = text(t18_value);
			t19 = space();
			t20 = text(t20_value);
			t21 = space();
			td3 = element("td");
			t22 = space();
			td4 = element("td");
			t23 = text(t23_value);
			t24 = space();
			t25 = text(t25_value);
			t26 = space();
			tr2 = element("tr");
			td5 = element("td");
			t27 = text(t27_value);
			t28 = space();
			t29 = text(t29_value);
			t30 = space();
			td6 = element("td");
			t31 = space();
			td7 = element("td");
			t32 = text(t32_value);
			t33 = space();
			t34 = text(t34_value);
			t35 = space();
			td8 = element("td");
			t36 = space();
			td9 = element("td");
			t37 = text(t37_value);
			t38 = space();
			t39 = text(t39_value);
			t40 = space();
			tr3 = element("tr");
			td10 = element("td");
			td10.textContent = `${gettext("Celkem")}`;
			t42 = space();
			td11 = element("td");
			t43 = space();
			td12 = element("td");
			t44 = space();
			td13 = element("td");
			t45 = space();
			td14 = element("td");
			t46 = text(t46_value);
			t47 = space();
			t48 = text(t48_value);
			attr(table, "class", "uk-table basketTable ");
			attr(div, "class", "uk-overflow-auto");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, table);
			append(table, thead);
			append(thead, tr0);
			append(tr0, th0);
			append(tr0, t1);
			append(tr0, th1);
			append(tr0, t3);
			append(tr0, th2);
			append(tr0, t5);
			append(tr0, th3);
			append(tr0, t7);
			append(tr0, th4);
			append(table, t9);
			append(table, tbody);

			for (let i = 0; i < each_blocks.length; i += 1) {
				if (each_blocks[i]) {
					each_blocks[i].m(tbody, null);
				}
			}

			append(table, t10);
			append(table, tfoot);
			if (if_block0) if_block0.m(tfoot, null);
			append(tfoot, t11);
			append(tfoot, tr1);
			append(tr1, td0);
			append(td0, t12);
			append(td0, t13);
			append(td0, t14);
			append(td0, t15);
			if (if_block1) if_block1.m(td0, null);
			append(tr1, t16);
			append(tr1, td1);
			append(tr1, t17);
			append(tr1, td2);
			append(td2, t18);
			append(td2, t19);
			append(td2, t20);
			append(tr1, t21);
			append(tr1, td3);
			append(tr1, t22);
			append(tr1, td4);
			append(td4, t23);
			append(td4, t24);
			append(td4, t25);
			append(tfoot, t26);
			append(tfoot, tr2);
			append(tr2, td5);
			append(td5, t27);
			append(td5, t28);
			append(td5, t29);
			append(tr2, t30);
			append(tr2, td6);
			append(tr2, t31);
			append(tr2, td7);
			append(td7, t32);
			append(td7, t33);
			append(td7, t34);
			append(tr2, t35);
			append(tr2, td8);
			append(tr2, t36);
			append(tr2, td9);
			append(td9, t37);
			append(td9, t38);
			append(td9, t39);
			append(tfoot, t40);
			append(tfoot, tr3);
			append(tr3, td10);
			append(tr3, t42);
			append(tr3, td11);
			append(tr3, t43);
			append(tr3, td12);
			append(tr3, t44);
			append(tr3, td13);
			append(tr3, t45);
			append(tr3, td14);
			append(td14, t46);
			append(td14, t47);
			append(td14, t48);
		},
		p(ctx, dirty) {
			if (dirty & /*$basketStore, gettext*/ 2) {
				each_value = /*$basketStore*/ ctx[1].items;
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(tbody, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}

			if (/*$basketDiscount*/ ctx[2] > 0) {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_9(ctx);
					if_block0.c();
					if_block0.m(tfoot, t11);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (dirty & /*$orderStore*/ 8 && t14_value !== (t14_value = /*$orderStore*/ ctx[3].delivery_title + "")) set_data(t14, t14_value);

			if (/*$orderStore*/ ctx[3].delivery_data && /*$orderStore*/ ctx[3].delivery_data.subtitleHTML) {
				if (if_block1) {
					if_block1.p(ctx, dirty);
				} else {
					if_block1 = create_if_block_8(ctx);
					if_block1.c();
					if_block1.m(td0, null);
				}
			} else if (if_block1) {
				if_block1.d(1);
				if_block1 = null;
			}

			if (dirty & /*$orderStore*/ 8 && t18_value !== (t18_value = /*$orderStore*/ ctx[3].price_delivery.toLocaleString() + "")) set_data(t18, t18_value);
			if (dirty & /*$basketStore*/ 2 && t20_value !== (t20_value = /*$basketStore*/ ctx[1].payment_currency + "")) set_data(t20, t20_value);
			if (dirty & /*$orderStore*/ 8 && t23_value !== (t23_value = /*$orderStore*/ ctx[3].price_delivery.toLocaleString() + "")) set_data(t23, t23_value);
			if (dirty & /*$basketStore*/ 2 && t25_value !== (t25_value = /*$basketStore*/ ctx[1].payment_currency + "")) set_data(t25, t25_value);
			if (dirty & /*$orderStore*/ 8 && t29_value !== (t29_value = /*$orderStore*/ ctx[3].payment_title + "")) set_data(t29, t29_value);
			if (dirty & /*$orderStore*/ 8 && t32_value !== (t32_value = /*$orderStore*/ ctx[3].price_payment.toLocaleString() + "")) set_data(t32, t32_value);
			if (dirty & /*$basketStore*/ 2 && t34_value !== (t34_value = /*$basketStore*/ ctx[1].payment_currency + "")) set_data(t34, t34_value);
			if (dirty & /*$orderStore*/ 8 && t37_value !== (t37_value = /*$orderStore*/ ctx[3].price_payment.toLocaleString() + "")) set_data(t37, t37_value);
			if (dirty & /*$basketStore*/ 2 && t39_value !== (t39_value = /*$basketStore*/ ctx[1].payment_currency + "")) set_data(t39, t39_value);
			if (dirty & /*$basketPrice, $orderStore*/ 24 && t46_value !== (t46_value = (/*$basketPrice*/ ctx[4] + /*$orderStore*/ ctx[3].price_delivery + /*$orderStore*/ ctx[3].price_payment).toLocaleString() + "")) set_data(t46, t46_value);
			if (dirty & /*$basketStore*/ 2 && t48_value !== (t48_value = /*$basketStore*/ ctx[1].payment_currency + "")) set_data(t48, t48_value);
		},
		d(detaching) {
			if (detaching) detach(div);
			destroy_each(each_blocks, detaching);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
		}
	};
}

// (33:24) {#if item.description}
function create_if_block_10(ctx) {
	let br;
	let t_value = /*item*/ ctx[5].description + "";
	let t;

	return {
		c() {
			br = element("br");
			t = text(t_value);
		},
		m(target, anchor) {
			insert(target, br, anchor);
			insert(target, t, anchor);
		},
		p(ctx, dirty) {
			if (dirty & /*$basketStore*/ 2 && t_value !== (t_value = /*item*/ ctx[5].description + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(br);
			if (detaching) detach(t);
		}
	};
}

// (29:12) {#each $basketStore.items as item}
function create_each_block(ctx) {
	let tr;
	let td0;
	let strong;
	let t0_value = /*item*/ ctx[5].title + "";
	let t0;
	let t1;
	let t2;
	let td1;

	let t3_value = (/*item*/ ctx[5].book_type == 'PRINT'
	? gettext('tištěná')
	: gettext('ekniha')) + "";

	let t3;
	let t4;
	let td2;
	let t5_value = /*item*/ ctx[5].unit_price.toLocaleString() + "";
	let t5;
	let t6;
	let t7_value = /*item*/ ctx[5].unit_price_currency + "";
	let t7;
	let t8;
	let td3;
	let t9_value = /*item*/ ctx[5].quantity + "";
	let t9;
	let t10;
	let td4;
	let t11_value = /*item*/ ctx[5].full_price.toLocaleString() + "";
	let t11;
	let t12;
	let t13_value = /*item*/ ctx[5].unit_price_currency + "";
	let t13;
	let t14;
	let if_block = /*item*/ ctx[5].description && create_if_block_10(ctx);

	return {
		c() {
			tr = element("tr");
			td0 = element("td");
			strong = element("strong");
			t0 = text(t0_value);
			t1 = space();
			if (if_block) if_block.c();
			t2 = space();
			td1 = element("td");
			t3 = text(t3_value);
			t4 = space();
			td2 = element("td");
			t5 = text(t5_value);
			t6 = space();
			t7 = text(t7_value);
			t8 = space();
			td3 = element("td");
			t9 = text(t9_value);
			t10 = space();
			td4 = element("td");
			t11 = text(t11_value);
			t12 = space();
			t13 = text(t13_value);
			t14 = space();
		},
		m(target, anchor) {
			insert(target, tr, anchor);
			append(tr, td0);
			append(td0, strong);
			append(strong, t0);
			append(td0, t1);
			if (if_block) if_block.m(td0, null);
			append(tr, t2);
			append(tr, td1);
			append(td1, t3);
			append(tr, t4);
			append(tr, td2);
			append(td2, t5);
			append(td2, t6);
			append(td2, t7);
			append(tr, t8);
			append(tr, td3);
			append(td3, t9);
			append(tr, t10);
			append(tr, td4);
			append(td4, t11);
			append(td4, t12);
			append(td4, t13);
			append(tr, t14);
		},
		p(ctx, dirty) {
			if (dirty & /*$basketStore*/ 2 && t0_value !== (t0_value = /*item*/ ctx[5].title + "")) set_data(t0, t0_value);

			if (/*item*/ ctx[5].description) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block_10(ctx);
					if_block.c();
					if_block.m(td0, null);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}

			if (dirty & /*$basketStore*/ 2 && t3_value !== (t3_value = (/*item*/ ctx[5].book_type == 'PRINT'
			? gettext('tištěná')
			: gettext('ekniha')) + "")) set_data(t3, t3_value);

			if (dirty & /*$basketStore*/ 2 && t5_value !== (t5_value = /*item*/ ctx[5].unit_price.toLocaleString() + "")) set_data(t5, t5_value);
			if (dirty & /*$basketStore*/ 2 && t7_value !== (t7_value = /*item*/ ctx[5].unit_price_currency + "")) set_data(t7, t7_value);
			if (dirty & /*$basketStore*/ 2 && t9_value !== (t9_value = /*item*/ ctx[5].quantity + "")) set_data(t9, t9_value);
			if (dirty & /*$basketStore*/ 2 && t11_value !== (t11_value = /*item*/ ctx[5].full_price.toLocaleString() + "")) set_data(t11, t11_value);
			if (dirty & /*$basketStore*/ 2 && t13_value !== (t13_value = /*item*/ ctx[5].unit_price_currency + "")) set_data(t13, t13_value);
		},
		d(detaching) {
			if (detaching) detach(tr);
			if (if_block) if_block.d();
		}
	};
}

// (50:12) {#if $basketDiscount > 0}
function create_if_block_9(ctx) {
	let tr;
	let td0;
	let strong;
	let t1;
	let td1;
	let t2;
	let td2;
	let t3;
	let t4_value = /*$basketDiscount*/ ctx[2].toLocaleString() + "";
	let t4;
	let t5;
	let t6_value = /*$basketStore*/ ctx[1].payment_currency + "";
	let t6;
	let t7;
	let td3;
	let t8;
	let td4;
	let t9;
	let t10_value = /*$basketDiscount*/ ctx[2].toLocaleString() + "";
	let t10;
	let t11;
	let t12_value = /*$basketStore*/ ctx[1].payment_currency + "";
	let t12;

	return {
		c() {
			tr = element("tr");
			td0 = element("td");
			strong = element("strong");
			strong.textContent = `${gettext("Sleva")}`;
			t1 = space();
			td1 = element("td");
			t2 = space();
			td2 = element("td");
			t3 = text("-");
			t4 = text(t4_value);
			t5 = space();
			t6 = text(t6_value);
			t7 = space();
			td3 = element("td");
			t8 = space();
			td4 = element("td");
			t9 = text("-");
			t10 = text(t10_value);
			t11 = space();
			t12 = text(t12_value);
		},
		m(target, anchor) {
			insert(target, tr, anchor);
			append(tr, td0);
			append(td0, strong);
			append(tr, t1);
			append(tr, td1);
			append(tr, t2);
			append(tr, td2);
			append(td2, t3);
			append(td2, t4);
			append(td2, t5);
			append(td2, t6);
			append(tr, t7);
			append(tr, td3);
			append(tr, t8);
			append(tr, td4);
			append(td4, t9);
			append(td4, t10);
			append(td4, t11);
			append(td4, t12);
		},
		p(ctx, dirty) {
			if (dirty & /*$basketDiscount*/ 4 && t4_value !== (t4_value = /*$basketDiscount*/ ctx[2].toLocaleString() + "")) set_data(t4, t4_value);
			if (dirty & /*$basketStore*/ 2 && t6_value !== (t6_value = /*$basketStore*/ ctx[1].payment_currency + "")) set_data(t6, t6_value);
			if (dirty & /*$basketDiscount*/ 4 && t10_value !== (t10_value = /*$basketDiscount*/ ctx[2].toLocaleString() + "")) set_data(t10, t10_value);
			if (dirty & /*$basketStore*/ 2 && t12_value !== (t12_value = /*$basketStore*/ ctx[1].payment_currency + "")) set_data(t12, t12_value);
		},
		d(detaching) {
			if (detaching) detach(tr);
		}
	};
}

// (65:20) {#if $orderStore.delivery_data && $orderStore.delivery_data.subtitleHTML}
function create_if_block_8(ctx) {
	let div;
	let raw_value = /*$orderStore*/ ctx[3].delivery_data.subtitleHTML + "";

	return {
		c() {
			div = element("div");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			div.innerHTML = raw_value;
		},
		p(ctx, dirty) {
			if (dirty & /*$orderStore*/ 8 && raw_value !== (raw_value = /*$orderStore*/ ctx[3].delivery_data.subtitleHTML + "")) div.innerHTML = raw_value;;
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (106:8) {#if $orderStore.customer_type == 'PERSONAL'}
function create_if_block_6(ctx) {
	let t_value = gettext("Soukromá osoba") + "";
	let t;

	return {
		c() {
			t = text(t_value);
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (109:8) {#if $orderStore.customer_type == 'COMPANY'}
function create_if_block_5(ctx) {
	let t_value = gettext("Firma") + "";
	let t;

	return {
		c() {
			t = text(t_value);
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (115:13) {#if $orderStore.customer_type == 'COMPANY'}
function create_if_block_4(ctx) {
	let t0_value = gettext("Název společnosti") + "";
	let t0;
	let t1;
	let strong0;
	let t2_value = (/*$orderStore*/ ctx[3].company_name != undefined && /*$orderStore*/ ctx[3].company_name) + "";
	let t2;
	let t3;
	let br;
	let t4;
	let t5_value = gettext("IČ:") + "";
	let t5;
	let t6;
	let strong1;
	let t7_value = (/*$orderStore*/ ctx[3].company_id != undefined && /*$orderStore*/ ctx[3].company_id) + "";
	let t7;

	return {
		c() {
			t0 = text(t0_value);
			t1 = space();
			strong0 = element("strong");
			t2 = text(t2_value);
			t3 = space();
			br = element("br");
			t4 = space();
			t5 = text(t5_value);
			t6 = space();
			strong1 = element("strong");
			t7 = text(t7_value);
		},
		m(target, anchor) {
			insert(target, t0, anchor);
			insert(target, t1, anchor);
			insert(target, strong0, anchor);
			append(strong0, t2);
			insert(target, t3, anchor);
			insert(target, br, anchor);
			insert(target, t4, anchor);
			insert(target, t5, anchor);
			insert(target, t6, anchor);
			insert(target, strong1, anchor);
			append(strong1, t7);
		},
		p(ctx, dirty) {
			if (dirty & /*$orderStore*/ 8 && t2_value !== (t2_value = (/*$orderStore*/ ctx[3].company_name != undefined && /*$orderStore*/ ctx[3].company_name) + "")) set_data(t2, t2_value);
			if (dirty & /*$orderStore*/ 8 && t7_value !== (t7_value = (/*$orderStore*/ ctx[3].company_id != undefined && /*$orderStore*/ ctx[3].company_id) + "")) set_data(t7, t7_value);
		},
		d(detaching) {
			if (detaching) detach(t0);
			if (detaching) detach(t1);
			if (detaching) detach(strong0);
			if (detaching) detach(t3);
			if (detaching) detach(br);
			if (detaching) detach(t4);
			if (detaching) detach(t5);
			if (detaching) detach(t6);
			if (detaching) detach(strong1);
		}
	};
}

// (137:12) {#if $orderStore.delivery_address_street}
function create_if_block_3(ctx) {
	let t0_value = gettext("Doručovací adresa:") + "";
	let t0;
	let br0;
	let t1;
	let strong;
	let t2_value = /*$orderStore*/ ctx[3].delivery_address_street + "";
	let t2;
	let br1;

	return {
		c() {
			t0 = text(t0_value);
			br0 = element("br");
			t1 = space();
			strong = element("strong");
			t2 = text(t2_value);
			br1 = element("br");
		},
		m(target, anchor) {
			insert(target, t0, anchor);
			insert(target, br0, anchor);
			insert(target, t1, anchor);
			insert(target, strong, anchor);
			append(strong, t2);
			insert(target, br1, anchor);
		},
		p(ctx, dirty) {
			if (dirty & /*$orderStore*/ 8 && t2_value !== (t2_value = /*$orderStore*/ ctx[3].delivery_address_street + "")) set_data(t2, t2_value);
		},
		d(detaching) {
			if (detaching) detach(t0);
			if (detaching) detach(br0);
			if (detaching) detach(t1);
			if (detaching) detach(strong);
			if (detaching) detach(br1);
		}
	};
}

// (142:12) {#if $orderStore.delivery_address_city}
function create_if_block_2(ctx) {
	let t0_value = gettext("město:") + "";
	let t0;
	let t1;
	let strong;
	let t2_value = /*$orderStore*/ ctx[3].delivery_address_city + "";
	let t2;
	let t3;

	return {
		c() {
			t0 = text(t0_value);
			t1 = space();
			strong = element("strong");
			t2 = text(t2_value);
			t3 = text(",");
		},
		m(target, anchor) {
			insert(target, t0, anchor);
			insert(target, t1, anchor);
			insert(target, strong, anchor);
			append(strong, t2);
			insert(target, t3, anchor);
		},
		p(ctx, dirty) {
			if (dirty & /*$orderStore*/ 8 && t2_value !== (t2_value = /*$orderStore*/ ctx[3].delivery_address_city + "")) set_data(t2, t2_value);
		},
		d(detaching) {
			if (detaching) detach(t0);
			if (detaching) detach(t1);
			if (detaching) detach(strong);
			if (detaching) detach(t3);
		}
	};
}

// (146:12) {#if $orderStore.delivery_address_zip}
function create_if_block_1(ctx) {
	let t0_value = /*$orderStore*/ ctx[3].delivery_address_zip + "";
	let t0;
	let t1;
	let br;

	return {
		c() {
			t0 = text(t0_value);
			t1 = space();
			br = element("br");
		},
		m(target, anchor) {
			insert(target, t0, anchor);
			insert(target, t1, anchor);
			insert(target, br, anchor);
		},
		p(ctx, dirty) {
			if (dirty & /*$orderStore*/ 8 && t0_value !== (t0_value = /*$orderStore*/ ctx[3].delivery_address_zip + "")) set_data(t0, t0_value);
		},
		d(detaching) {
			if (detaching) detach(t0);
			if (detaching) detach(t1);
			if (detaching) detach(br);
		}
	};
}

// (151:12) {#if $orderStore.order_description}
function create_if_block(ctx) {
	let t0_value = gettext("Poznámka:") + "";
	let t0;
	let br;
	let t1_value = /*$orderStore*/ ctx[3].order_description + "";
	let t1;

	return {
		c() {
			t0 = text(t0_value);
			br = element("br");
			t1 = text(t1_value);
		},
		m(target, anchor) {
			insert(target, t0, anchor);
			insert(target, br, anchor);
			insert(target, t1, anchor);
		},
		p(ctx, dirty) {
			if (dirty & /*$orderStore*/ 8 && t1_value !== (t1_value = /*$orderStore*/ ctx[3].order_description + "")) set_data(t1, t1_value);
		},
		d(detaching) {
			if (detaching) detach(t0);
			if (detaching) detach(br);
			if (detaching) detach(t1);
		}
	};
}

function create_fragment(ctx) {
	let h1;
	let t1;
	let div0;
	let t3;
	let t4;
	let div5;
	let div1;
	let t5;
	let t6;
	let div4;
	let div2;
	let t7;
	let t8_value = gettext("Jméno a příjmení:") + "";
	let t8;
	let t9;
	let strong0;
	let t10_value = (/*$orderStore*/ ctx[3].name_and_surname != undefined && /*$orderStore*/ ctx[3].name_and_surname) + "";
	let t10;
	let t11;
	let br0;
	let t12;
	let t13_value = gettext("email") + "";
	let t13;
	let t14;
	let strong1;
	let t15_value = (/*$orderStore*/ ctx[3].email != undefined && /*$orderStore*/ ctx[3].email) + "";
	let t15;
	let t16;
	let br1;
	let t17;
	let t18_value = gettext("tel.:") + "";
	let t18;
	let t19;
	let strong2;
	let t20_value = (/*$orderStore*/ ctx[3].phone != undefined && /*$orderStore*/ ctx[3].phone) + "";
	let t20;
	let t21;
	let div3;
	let t22_value = gettext("ulice:") + "";
	let t22;
	let t23;
	let strong3;
	let t24_value = (/*$orderStore*/ ctx[3].address_street != undefined && /*$orderStore*/ ctx[3].address_street) + "";
	let t24;
	let t25;
	let br2;
	let t26;
	let t27_value = gettext("město:") + "";
	let t27;
	let t28;
	let strong4;
	let t29_value = (/*$orderStore*/ ctx[3].address_city != undefined && /*$orderStore*/ ctx[3].address_city) + "";
	let t29;
	let t30;
	let strong5;
	let t31_value = (/*$orderStore*/ ctx[3].address_zip != undefined && /*$orderStore*/ ctx[3].address_zip) + "";
	let t31;
	let t32;
	let br3;
	let t33;
	let t34_value = gettext("stát:") + "";
	let t34;
	let t35;
	let strong6;
	let t36_value = (/*$orderStore*/ ctx[3].address_country != undefined && /*$orderStore*/ ctx[3].address_country) + "";
	let t36;
	let t37;
	let br4;
	let t38;
	let t39;
	let t40;
	let t41;
	let if_block0 = /*$basketItemsCount*/ ctx[0] > 0 && create_if_block_7(ctx);
	let if_block1 = /*$orderStore*/ ctx[3].customer_type == 'PERSONAL' && create_if_block_6(ctx);
	let if_block2 = /*$orderStore*/ ctx[3].customer_type == 'COMPANY' && create_if_block_5(ctx);
	let if_block3 = /*$orderStore*/ ctx[3].customer_type == 'COMPANY' && create_if_block_4(ctx);
	let if_block4 = /*$orderStore*/ ctx[3].delivery_address_street && create_if_block_3(ctx);
	let if_block5 = /*$orderStore*/ ctx[3].delivery_address_city && create_if_block_2(ctx);
	let if_block6 = /*$orderStore*/ ctx[3].delivery_address_zip && create_if_block_1(ctx);
	let if_block7 = /*$orderStore*/ ctx[3].order_description && create_if_block(ctx);

	return {
		c() {
			h1 = element("h1");
			h1.textContent = `${gettext("Shrnutí")}`;
			t1 = space();
			div0 = element("div");
			div0.textContent = " ";
			t3 = space();
			if (if_block0) if_block0.c();
			t4 = space();
			div5 = element("div");
			div1 = element("div");
			if (if_block1) if_block1.c();
			t5 = space();
			if (if_block2) if_block2.c();
			t6 = space();
			div4 = element("div");
			div2 = element("div");
			if (if_block3) if_block3.c();
			t7 = space();
			t8 = text(t8_value);
			t9 = space();
			strong0 = element("strong");
			t10 = text(t10_value);
			t11 = space();
			br0 = element("br");
			t12 = space();
			t13 = text(t13_value);
			t14 = space();
			strong1 = element("strong");
			t15 = text(t15_value);
			t16 = space();
			br1 = element("br");
			t17 = space();
			t18 = text(t18_value);
			t19 = space();
			strong2 = element("strong");
			t20 = text(t20_value);
			t21 = space();
			div3 = element("div");
			t22 = text(t22_value);
			t23 = space();
			strong3 = element("strong");
			t24 = text(t24_value);
			t25 = space();
			br2 = element("br");
			t26 = space();
			t27 = text(t27_value);
			t28 = space();
			strong4 = element("strong");
			t29 = text(t29_value);
			t30 = text(",\n            ");
			strong5 = element("strong");
			t31 = text(t31_value);
			t32 = space();
			br3 = element("br");
			t33 = space();
			t34 = text(t34_value);
			t35 = space();
			strong6 = element("strong");
			t36 = text(t36_value);
			t37 = space();
			br4 = element("br");
			t38 = space();
			if (if_block4) if_block4.c();
			t39 = space();
			if (if_block5) if_block5.c();
			t40 = space();
			if (if_block6) if_block6.c();
			t41 = space();
			if (if_block7) if_block7.c();
			attr(div0, "class", "basketInfoEmpty");
			attr(div1, "class", "basketOrderPadd");
			attr(div2, "class", "basketOrderPerson");
			attr(div3, "class", "basketOrderPayment");
			attr(div4, "class", "basketOrder basketOrderPadd");
		},
		m(target, anchor) {
			insert(target, h1, anchor);
			insert(target, t1, anchor);
			insert(target, div0, anchor);
			insert(target, t3, anchor);
			if (if_block0) if_block0.m(target, anchor);
			insert(target, t4, anchor);
			insert(target, div5, anchor);
			append(div5, div1);
			if (if_block1) if_block1.m(div1, null);
			append(div1, t5);
			if (if_block2) if_block2.m(div1, null);
			append(div5, t6);
			append(div5, div4);
			append(div4, div2);
			if (if_block3) if_block3.m(div2, null);
			append(div2, t7);
			append(div2, t8);
			append(div2, t9);
			append(div2, strong0);
			append(strong0, t10);
			append(div2, t11);
			append(div2, br0);
			append(div2, t12);
			append(div2, t13);
			append(div2, t14);
			append(div2, strong1);
			append(strong1, t15);
			append(div2, t16);
			append(div2, br1);
			append(div2, t17);
			append(div2, t18);
			append(div2, t19);
			append(div2, strong2);
			append(strong2, t20);
			append(div4, t21);
			append(div4, div3);
			append(div3, t22);
			append(div3, t23);
			append(div3, strong3);
			append(strong3, t24);
			append(div3, t25);
			append(div3, br2);
			append(div3, t26);
			append(div3, t27);
			append(div3, t28);
			append(div3, strong4);
			append(strong4, t29);
			append(div3, t30);
			append(div3, strong5);
			append(strong5, t31);
			append(div3, t32);
			append(div3, br3);
			append(div3, t33);
			append(div3, t34);
			append(div3, t35);
			append(div3, strong6);
			append(strong6, t36);
			append(div3, t37);
			append(div3, br4);
			append(div3, t38);
			if (if_block4) if_block4.m(div3, null);
			append(div3, t39);
			if (if_block5) if_block5.m(div3, null);
			append(div3, t40);
			if (if_block6) if_block6.m(div3, null);
			append(div3, t41);
			if (if_block7) if_block7.m(div3, null);
		},
		p(ctx, [dirty]) {
			if (/*$basketItemsCount*/ ctx[0] > 0) {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_7(ctx);
					if_block0.c();
					if_block0.m(t4.parentNode, t4);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (/*$orderStore*/ ctx[3].customer_type == 'PERSONAL') {
				if (if_block1) {
					if_block1.p(ctx, dirty);
				} else {
					if_block1 = create_if_block_6(ctx);
					if_block1.c();
					if_block1.m(div1, t5);
				}
			} else if (if_block1) {
				if_block1.d(1);
				if_block1 = null;
			}

			if (/*$orderStore*/ ctx[3].customer_type == 'COMPANY') {
				if (if_block2) {
					if_block2.p(ctx, dirty);
				} else {
					if_block2 = create_if_block_5(ctx);
					if_block2.c();
					if_block2.m(div1, null);
				}
			} else if (if_block2) {
				if_block2.d(1);
				if_block2 = null;
			}

			if (/*$orderStore*/ ctx[3].customer_type == 'COMPANY') {
				if (if_block3) {
					if_block3.p(ctx, dirty);
				} else {
					if_block3 = create_if_block_4(ctx);
					if_block3.c();
					if_block3.m(div2, t7);
				}
			} else if (if_block3) {
				if_block3.d(1);
				if_block3 = null;
			}

			if (dirty & /*$orderStore*/ 8 && t10_value !== (t10_value = (/*$orderStore*/ ctx[3].name_and_surname != undefined && /*$orderStore*/ ctx[3].name_and_surname) + "")) set_data(t10, t10_value);
			if (dirty & /*$orderStore*/ 8 && t15_value !== (t15_value = (/*$orderStore*/ ctx[3].email != undefined && /*$orderStore*/ ctx[3].email) + "")) set_data(t15, t15_value);
			if (dirty & /*$orderStore*/ 8 && t20_value !== (t20_value = (/*$orderStore*/ ctx[3].phone != undefined && /*$orderStore*/ ctx[3].phone) + "")) set_data(t20, t20_value);
			if (dirty & /*$orderStore*/ 8 && t24_value !== (t24_value = (/*$orderStore*/ ctx[3].address_street != undefined && /*$orderStore*/ ctx[3].address_street) + "")) set_data(t24, t24_value);
			if (dirty & /*$orderStore*/ 8 && t29_value !== (t29_value = (/*$orderStore*/ ctx[3].address_city != undefined && /*$orderStore*/ ctx[3].address_city) + "")) set_data(t29, t29_value);
			if (dirty & /*$orderStore*/ 8 && t31_value !== (t31_value = (/*$orderStore*/ ctx[3].address_zip != undefined && /*$orderStore*/ ctx[3].address_zip) + "")) set_data(t31, t31_value);
			if (dirty & /*$orderStore*/ 8 && t36_value !== (t36_value = (/*$orderStore*/ ctx[3].address_country != undefined && /*$orderStore*/ ctx[3].address_country) + "")) set_data(t36, t36_value);

			if (/*$orderStore*/ ctx[3].delivery_address_street) {
				if (if_block4) {
					if_block4.p(ctx, dirty);
				} else {
					if_block4 = create_if_block_3(ctx);
					if_block4.c();
					if_block4.m(div3, t39);
				}
			} else if (if_block4) {
				if_block4.d(1);
				if_block4 = null;
			}

			if (/*$orderStore*/ ctx[3].delivery_address_city) {
				if (if_block5) {
					if_block5.p(ctx, dirty);
				} else {
					if_block5 = create_if_block_2(ctx);
					if_block5.c();
					if_block5.m(div3, t40);
				}
			} else if (if_block5) {
				if_block5.d(1);
				if_block5 = null;
			}

			if (/*$orderStore*/ ctx[3].delivery_address_zip) {
				if (if_block6) {
					if_block6.p(ctx, dirty);
				} else {
					if_block6 = create_if_block_1(ctx);
					if_block6.c();
					if_block6.m(div3, t41);
				}
			} else if (if_block6) {
				if_block6.d(1);
				if_block6 = null;
			}

			if (/*$orderStore*/ ctx[3].order_description) {
				if (if_block7) {
					if_block7.p(ctx, dirty);
				} else {
					if_block7 = create_if_block(ctx);
					if_block7.c();
					if_block7.m(div3, null);
				}
			} else if (if_block7) {
				if_block7.d(1);
				if_block7 = null;
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(h1);
			if (detaching) detach(t1);
			if (detaching) detach(div0);
			if (detaching) detach(t3);
			if (if_block0) if_block0.d(detaching);
			if (detaching) detach(t4);
			if (detaching) detach(div5);
			if (if_block1) if_block1.d();
			if (if_block2) if_block2.d();
			if (if_block3) if_block3.d();
			if (if_block4) if_block4.d();
			if (if_block5) if_block5.d();
			if (if_block6) if_block6.d();
			if (if_block7) if_block7.d();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let $basketItemsCount;
	let $basketStore;
	let $basketDiscount;
	let $orderStore;
	let $basketPrice;
	component_subscribe($$self, basketItemsCount, $$value => $$invalidate(0, $basketItemsCount = $$value));
	component_subscribe($$self, basketStore, $$value => $$invalidate(1, $basketStore = $$value));
	component_subscribe($$self, basketDiscount, $$value => $$invalidate(2, $basketDiscount = $$value));
	component_subscribe($$self, orderStore, $$value => $$invalidate(3, $orderStore = $$value));
	component_subscribe($$self, basketPrice, $$value => $$invalidate(4, $basketPrice = $$value));
	return [$basketItemsCount, $basketStore, $basketDiscount, $orderStore, $basketPrice];
}

class Summary extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default Summary;